import { Link } from "react-router";
import React, { Component } from "react";

import "./404.scss";

class PageNotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
    };
    if (this.state.location.pathname.includes("only-with-us")) {
      this.props.router.push("/our-advantage");
    }
  }
  render() {
    return (
      <div className="page-not-found web-container">
        <h1>404</h1>
        <h2>
          We are very sorry, the page you were looking for has been <br />{" "}
          moved, deleted or does not exist.
        </h2>
        <h3>
          Click <Link to="/">here</Link> to go back to the Homepage.
        </h3>
      </div>
    );
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/404/index.js